module.exports = __webpack_public_path__ + "media/images/meetAnna-adult-6e3499f90b7d706886c3f59a1e1b2a89.svg";